/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function Friend({ width = 18, height = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="#8C8C8C"
    >
      {/* Diversity3Outlined icon from Material UI */}
      <path d="M6.32 13.01c.96.02 1.85.5 2.45 1.34A3.961 3.961 0 0 0 12 16c1.29 0 2.5-.62 3.23-1.66.6-.84 1.49-1.32 2.45-1.34-.72-1.22-3.6-2-5.68-2-2.07 0-4.96.78-5.68 2.01zM4 13c1.66 0 3-1.34 3-3S5.66 7 4 7s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm16 4c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-8-2c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z" />
      <path d="M21.98 16.5c-.02-.67-.47-1.24-1.11-1.41-.69-.19-1.41-.29-2.16-.29-1.49 0-2.86.38-4.03 1.04C14.1 15.31 13.06 15 12 15s-2.1.31-2.68.84c-1.18-.66-2.54-1.04-4.03-1.04-.75 0-1.47.1-2.16.29-.64.17-1.09.74-1.11 1.41 0 .02-.01.04-.02.06v5.44h2V17c.73-.19 1.39-.25 2-.24 1.53.04 2.89.62 3.76 1.52.15.16.36.25.58.25H10c.22 0 .43-.09.58-.25.87-.9 2.23-1.48 3.76-1.52.61-.01 1.27.05 2 .24v5h2v-5.44c-.01-.02-.02-.04-.02-.06-.01-.16-.01-.29-.02-.43h.02c.01-.14.01-.27.02-.4z" />
    </svg>
  );
}

export default Friend;
